export enum enumSecurityRequired {
  'Default Security'= 1,
  'Generate Code',
  'Security Code',
  'SMS Auth',
  None
}

export namespace enumSecurityRequired {
  export function values() {
    return Object.keys(enumSecurityRequired).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
